import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import './Confirmation.css'
import { useState } from 'react'

const Confirmation = ({ text, affirm, cancel, affirmFunction, cancelFunction }) => {
  return (
    <Dialog
      open={true}
      onClose={cancelFunction}
      aria-labelledby="alert-dialog-title"
      className="parent_dialog_settings"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent sx={{ paddingBottom: 0 }}>
        <DialogContentText id="alert-dialog-description" className="dialog_content_main">
          {text}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ padding: '20px', paddingTop: 0 }}>
        <Button className="action_cta_dialog" onClick={cancelFunction}>
          {cancel}
        </Button>
        {affirm && (
          <Button className="action_cta_dialog affirm_cta" onClick={affirmFunction} autoFocus>
            {affirm}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}
export default Confirmation
